import { Controller } from "@hotwired/stimulus"

// Glisser-déposer natif de la banque de variables : lignes entre catégories, catégories entre
// elles. Chaque dépôt envoie l'organisation complète (ArrangeFields), sans recharger la page.
export default class extends Controller {
  static targets = ["group", "rows"]
  static values = { url: String, enabled: Boolean }

  connect() {
    if (!this.enabledValue) return
    this.onDragOver = this.dragOver.bind(this)
    this.onDrop = this.drop.bind(this)
    this.element.addEventListener("dragover", this.onDragOver)
    this.element.addEventListener("drop", this.onDrop)
  }

  disconnect() {
    if (!this.onDragOver) return
    this.element.removeEventListener("dragover", this.onDragOver)
    this.element.removeEventListener("drop", this.onDrop)
  }

  dragRow(event) {
    this.dragged = event.currentTarget
    this.kind = "row"
    event.dataTransfer.effectAllowed = "move"
    event.dataTransfer.setData("text/plain", this.dragged.dataset.ref)
  }

  dragGroup(event) {
    this.dragged = event.currentTarget.closest("[data-fields--arrange-target='group']")
    this.kind = "group"
    event.dataTransfer.effectAllowed = "move"
    event.dataTransfer.setData("text/plain", this.dragged.dataset.groupId)
  }

  dragOver(event) {
    if (!this.dragged) return
    event.preventDefault()
    if (this.kind === "row") {
      const body = event.target.closest("[data-fields--arrange-target='rows']")
      if (!body || !body.dataset.groupId) return
      body.querySelector(".fields-bank__empty")?.remove()
      const row = event.target.closest("tr[data-ref]")
      if (row && row !== this.dragged) {
        const after = event.clientY > row.getBoundingClientRect().top + row.offsetHeight / 2
        row.parentNode.insertBefore(this.dragged, after ? row.nextSibling : row)
      } else if (!row) {
        body.appendChild(this.dragged)
      }
    } else {
      const group = event.target.closest("[data-fields--arrange-target='group']")
      if (!group || group === this.dragged || !group.dataset.groupId) return
      const after = event.clientY > group.getBoundingClientRect().top + group.offsetHeight / 2
      group.parentNode.insertBefore(this.dragged, after ? group.nextSibling : group)
    }
  }

  async drop(event) {
    if (!this.dragged) return
    event.preventDefault()
    this.dragged = null
    const layout = this.groupTargets
      .filter((group) => group.dataset.groupId)
      .map((group) => ({
        id: Number(group.dataset.groupId),
        fields: Array.from(group.querySelectorAll("tr[data-ref]")).map((row) => row.dataset.ref)
      }))
    const token = document.querySelector("meta[name='csrf-token']")?.content
    const body = new FormData()
    body.append("layout", JSON.stringify(layout))
    const response = await fetch(this.urlValue, { method: "POST", body, headers: { "X-CSRF-Token": token } })
    if (!response.ok) window.Turbo.visit(window.location.href, { action: "replace" })
  }
}
